import "./JsonTpl.css";
import { TblDefEdit, FldDefList } from "../../manage2/TableDesign/TableDesign";
import { useForm } from "react-hook-form";
import { randomUUID } from "../../axios_with_token";

export default function JsonTpl({fldName, form, fldDef, opts, forms, path, name}){
    opts = opts || {};
    // const jsonTplForm = useForm();
    // const forms = {};
    // [] or, use master form with fldname prefix?
    return <>
        <div>JsonTpl</div>
        <FldDefList
            tblDef={{
                inputSettings: fldDef
            }}
            fldDefEdits={{}}

            // form={jsonTplForm}
            forms={forms}
            name={name}
            path={path}
        ></FldDefList>
        {form.formState.errors[fldName] && <p className="fld-error">{form.formState.errors[fldName].message}</p>}
    </>;
}